import { getToken, setToken, removeToken } from '@/utils/auth'
import request from '@/utils/request'

const state = {
  token: getToken() || '',
  user: null,
  org: null,
  profile: null,
  menus: []
}

const mutations = {
  SET_TOKEN(state, token) { state.token = token },
  SET_USER(state, user) { state.user = user },
  SET_ORG(state, org) { state.org = org },
  SET_PROFILE(state, profile) { state.profile = profile },
  SET_MENUS(state, menus) { state.menus = menus || [] }
}

const actions = {
  login({ commit }, form) {
    return request({ url: '/storeapi/auth/login', method: 'post', data: form }).then(res => {
      commit('SET_TOKEN', res.data.token)
      setToken(res.data.token)
      commit('SET_USER', res.data.user)
      commit('SET_ORG', res.data.org)
      commit('SET_MENUS', res.data.menus)
      return res
    })
  },
  getInfo({ commit }) {
    return request({ url: '/storeapi/auth/info', method: 'get' }).then(res => {
      commit('SET_USER', res.data.user)
      commit('SET_ORG', res.data.org)
      commit('SET_PROFILE', res.data.profile)
      commit('SET_MENUS', res.data.menus)
      return res.data
    })
  },
  logout({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_USER', null)
    commit('SET_ORG', null)
    commit('SET_PROFILE', null)
    commit('SET_MENUS', [])
    removeToken()
  },
  resetToken({ commit }) {
    commit('SET_TOKEN', '')
    removeToken()
  }
}

export default { namespaced: true, state, mutations, actions }
